<template>
  <ul class="category_wrap">
    <li class="user_name">
      <span>{{ isLoggedIn ? `${getCurrentUser.memberNm} 님` : '로그인' }}</span>
      <div class="close cursor" @click="$emit('close')">X</div>
    </li>
    <li
      class="category_toggle_btn cursor flex-center white-txt"
      @click="moveAndClose"
    >
      <div class="menu_icon_wrap">
        <div class="menu-border"></div>
        <div class="menu-border"></div>
        <div class="menu-border"></div>
      </div>
      <button>
        <!-- <span class="ham_logo"></span> -->
        <span class="base_NB18">분야별 도서보기</span>
      </button>
    </li>
    <li class="category_list active">
      <!-- <ul v-if="hasEventBook">
        <li style="background-color: greenyellow;">
          <router-link
            :to="{
              name: 'books_event',
              params: { order: 1 }
            }"
          >
            <span class="catgry-btn flex base_CT16">
              이벤트(신학기 도서할인)
            </span>
          </router-link>
        </li>
      </ul> -->
      <ul v-if="getCatgryList">
        <li
          v-for="(ctgry, i) in getCatgryList"
          :key="i + 'catgry'"
          :class="{ on: i === isMouseOver }"
          @mouseover="mouseoverList(i)"
          @click="moveCategory(ctgry)"
        >
          <span class="catgry-btn base_CT16">
            {{ ctgry.catgryNm }}
            <span class="catgry_desc" v-if="ctgry.catgryNm != '전체'">
              ({{ ctgry.childCnt }})
            </span>
          </span>
          <ul v-if="ctgry.subCatgryList" class="subCatgry_wrap">
            <li
              v-for="(subctgry, idx) in ctgry.subCatgryList"
              :key="idx + 'subctgry'"
              @click.stop="moveSubCategory(ctgry, subctgry)"
            >
              <span class="catgry-btn base_CT16 subcatgry-btn">
                {{ subctgry.subCatgryNm }}
                <span class="catgry_desc"> ({{ subctgry.childCnt }}) </span>
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CatgryToggle',
  components: {},
  props: {},
  data() {
    return {
      isMouseOver: null,
      isCategryToggle: false
    }
  },
  computed: {
    ...mapGetters([
      'isSidebarOpen',
      'isAuthLoading',
      'getCurrentUser',
      'getMainCategories',
      'getMainSubcategories',
      'isShowLineBanner',
      'getMainEventCategories'
    ]),
    getCatgryList() {
      return this.getMainCategories || []
    },
    getSubCatgryList() {
      return this.getMainSubCategories || []
    },
    isLoggedIn() {
      return this.getCurrentUser
    },
    hasEventBook() {
      if (this.getMainEventCategories?.count > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleCategryList() {
      this.isCategryToggle = !this.isCategryToggle
      this.isMouseOver = null
    },
    toggleCategryClose() {
      if (!this.isCategryToggle) return

      this.isCategryToggle = false
    },
    moveAndClose() {
      let ctgry = {
        'catgryCd': 'A',
        'catgryNm': '전체',
        'id': 'A',
        'title': '전체'
      }
      this.toggleCategryList
      this.moveCategory(ctgry)
    },
    moveCategory(ctgry) {
      if (ctgry.catgryCd == 'A' || !ctgry.subCatgryList?.length) {
        this.isCategryToggle = false
        this.isMouseOver = null
        this.$router.push({
          name: 'category_books',
          params: {
            category: ctgry.catgryCd,
            subCategory: ctgry.catgryCd
          }
        })
      } else {
        this.$router.push({
          name: 'category_books',
          params: {
            category: ctgry.catgryCd,
            subCategory: ctgry.catgryCd
          }
        })
      }
    },
    mouseoverList(i) {
      this.isMouseOver = i
    },
    moveSubCategory(ctgry, subctgry) {
      this.$router.push({
        name: 'category_books',
        params: {
          category: 'null',
          subCategory: 'null',
          subCategoryNm: 'null'
        }
      })
      this.$router.push({
        name: 'category_books',
        params: {
          category: ctgry.catgryCd,
          subCategory: subctgry.subCatgryCd,
          subCategoryNm: subctgry.subCatgryNm
        }
      })
      this.isCategryToggle = false
      this.isMouseOver = null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
.top_toggle {
  height: 100vh !important;
}
.category_wrap {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
  .user_name {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    padding: 0 1.5625rem;
    font-size: 1.2rem;
    font-weight: 700;
    // border: 1px solid $h_BLUE_02;
    // padding: ;
  }
  position: fixed;
  // top: 98px;
  .base_NB18 {
    font-size: 1rem;
  }
  width: 230px;

  height: 96px;
  //   position: relative;
  background-color: $h_sub_blue;
  .category_list > ul::-webkit-scrollbar {
    width: 5px;
  }
  .category_list > ul::-webkit-scrollbar-thumb {
    background-color: $h_sub_blue;
    border-radius: 10px;
    background-clip: padding-box;
    border: 1px solid transparent;
  }
  .category_list > ul::-webkit-scrollbar-track {
    background-color: grey;
    // border-radius: 10px;
    box-shadow: inset 0px 0px 5px white;
  }
  .category_list {
    width: -moz-available;
    width: -webkit-fill-available;
    width: fill-available;
    width: 100%;
    background-color: #fff;
    display: none;
    position: absolute;
    top: 96px;
    left: 0;
    // width: 100%;

    transition: all 0.2s;
    // padding: 0 24px;
    box-sizing: border-box;
    height: 100%;
    // max-height: 480px;
    .subCatgry_wrap li {
      padding: 2px 21px;
    }
    li {
      padding: 2px 32px;
      // overflow: hidden;
      color: $h_BLUE_01;
      // position: relative;
      // transition: all 0.1s;
      .catgry-btn {
        align-items: center;
        min-height: 36px;
        line-height: 35px;
        color: #000;
        .catgry_desc {
          font-size: 13px;
          color: $h_nav_color;
        }
      }
      span {
        // position: absolute;
        cursor: pointer;
      }
    }
    li:hover {
      background-color: #eaeaea;
    }
    li.on {
      background-color: #eaeaea;
    }
  }
  .category_list > ul {
    overflow-y: scroll;
    width: 100%;
    // max-height: 480px;
  }
  .active {
    display: inline-block;
    animation: fadeInDown 0.2s both;
    -webkit-transform-origin: 50% 0%;
  }
  .category_toggle_btn {
    height: 48px;
    background: $Logo_book;
  }
  .menu_icon_wrap {
    width: 22px;
    height: 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 24px;
    .menu-border {
      background-color: #ffffff;
      min-height: 2px;
      border-radius: 2px;
    }
    .menu-border:nth-child(1) {
      width: 22px;
    }
    .menu-border:nth-child(2) {
      width: 18px;
    }
    .menu-border:nth-child(3) {
      width: 14px;
    }
  }
}
.subCatgry_wrap {
  display: none;
  position: absolute;
  top: 0;
  left: 230px;
  width: -moz-available;
  width: -webkit-fill-available;
  width: 100%;
  background-color: #ffffff;
  max-height: 480px;
  overflow-y: auto;
}
.subCatgry_wrap::-webkit-scrollbar {
  width: 5px;
}
.subCatgry_wrap::-webkit-scrollbar-thumb {
  background-color: $h_sub_blue;
  border-radius: 10px;
  background-clip: padding-box;
  border: 1px solid transparent;
}
.subCatgry_wrap::-webkit-scrollbar-track {
  background-color: grey;
  // border-radius: 10px;
  box-shadow: inset 0px 0px 5px white;
}

.category_list > ul > li.on > ul {
  display: block;
}
.subcatgry-btn {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 35px;
}
</style>
